module.exports = __webpack_public_path__ + "static/img/visa.14180ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/payment-partner/visa.png
// module id = 5efT
// module chunks = 1